export default "__VITE_ASSET__NzZkCFa6__"